























import {Component, Vue} from 'vue-property-decorator';
import FacebookPixelTable from '@/screens/dashboard/facebookpixel/FacebookPixelTable.vue';
import {Location} from 'vue-router';

@Component({
  components: {
    FacebookPixelTable
  }
})
export default class FacebookPixelScreen extends Vue {
  get newFacebookPixel(): Location {
    return { name: 'dashboard.facebook-pixel-management.new' };
  }
}
